export default function debounce(func, wait, immediate) {
	var timeout;
	var debounced = function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};

	debounced.cancel = function() {
		clearTimeout(timeout);
		timeout = null;
	};

	// Alias for compatibility with call sites that expect lodash-style clear.
	debounced.clear = debounced.cancel;

	return debounced;
};
